// src/prototype/data/adapters/enterprisePrototypeFlag.ts
// ============================================================
// ENTERPRISE PROTOTYPE — FEATURE FLAG
//
// Sibling to VITE_ENABLE_EA_PROTOTYPE. Future enterprise surfaces (routes/UI, a later
// phase) must gate on this; the data layer itself is additive and unwired, so nothing
// reads it yet. Kept in its own module (uses import.meta.env) so the Node smoke test —
// which transpiles the pure data/adapter files — never has to handle import.meta.
// ============================================================

export const ENTERPRISE_PROTOTYPE_ENV = 'VITE_ENABLE_ENTERPRISE_PROTOTYPE';

/** True when the enterprise prototype is enabled for this build. Vite-only. */
export function isEnterprisePrototypeEnabled(): boolean {
  try {
    const env = (import.meta as unknown as { env?: Record<string, string> }).env;
    return env?.VITE_ENABLE_ENTERPRISE_PROTOTYPE === 'true';
  } catch {
    return false;
  }
}
